<template>
  <div class="page-security-profile">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <h1 class="head-block__title" v-html="$t('securityProfile.title')"></h1>
        <div class="row">
          <div class="col-x-lg-7 col-lg-7 col-md-7 col-xs-12">
            <p
              class="head-block__info"
              v-html="$t('securityProfile.info.text_1')"
            ></p>
            <p class="head-block__text" v-html="$t('securityProfile.text')"></p>
            <p
              class="head-block__info"
              v-html="$t('securityProfile.info.text_2')"
            ></p>
            <p
              class="head-block__info"
              v-html="$t('securityProfile.info.text_3')"
            ></p>
            <router-link
              @click.native="safeMainBtn()"
              :to="$t('securityProfile.button.link')"
              class="head-block__btn"
            >
              {{ $t("securityProfile.button.title") }}
            </router-link>
          </div>
          <div class="col-x-lg-5 col-lg-5 col-md-5 col-xs-12">
            <div class="head-block__image">
              <img
                v-if="$i18n.locale === 'ua'"
                src="~@/assets/img/security-profile/image-ua.png"
                alt=""
              />
              <img
                v-if="$i18n.locale === 'ru'"
                src="~@/assets/img/security-profile/image-ru.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('securityProfile.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "SecurityProfileView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Більше про безпеку Називін® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Ментол ❄, камфора та інші рослинні компоненти 🌿 також відсутні в складі Називін® Сенситив для зниження ризику алергій 👃💦 та реакцій гіперчутливості."
          },
          {
            property: "og:description",
            content: "Більше про безпеку Називін® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Больше о безопасности Називин® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Ментол ❄, камфора и другие растительные компоненты 🌿 также отсутствуют в составе Називин® Сенситив для снижения риска аллергии 👃💦 и реакций гиперчувствительности."
          },
          {
            property: "og:description",
            content: "Больше о безопасности Називин® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    safeMainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "safe_main_btn" });
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_security-profile";
</style>
